module.exports = __webpack_public_path__ + "media/Instruction_B11.9bb11339.mp3";